// @ts-nocheck
export const localeCodes =  [
  "en"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_507178a0",
      load: () => import("#nuxt-i18n/507178a0" /* webpackChunkName: "locale_en_46ts_507178a0" */),
      cache: true
    },
    {
      key: "locale_en_46ts_42adb5b2",
      load: () => import("#nuxt-i18n/42adb5b2" /* webpackChunkName: "locale_en_46ts_42adb5b2" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    iso: "en-GB",
    lang: "English",
    name: "United Kingdom",
    language: undefined
  }
]
/** client **/

/** client-end **/